import { lazy } from "react";
export { ASSESSMENT_PATH } from "./path";
export const AssessmentPage = lazy(() => import("./page"));
